/** @jsx jsx */
import type { MouseEvent } from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import CloseIcon from '@atlaskit/icon/core/cross-circle';
import Pressable from '@atlaskit/primitives/pressable';
import { components, type DropdownIndicatorProps } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import type { SelectOption } from '../../../../common/types.tsx';
import { DisplayWrapper, CloseIconWrapper } from '../../../../common/ui/picker/styled.tsx';

const styles = cssMap({
	dropdownIndicatorWrapper: {
		marginRight: token('space.025'),
		textAlign: 'center',
	},
	dropdownIndicatorWrapperOld: {
		marginRight: token('space.025'),
		textAlign: 'center',
		width: '32px',
	},
	iconWrapper: {
		display: 'flex',
		cursor: 'pointer',
		paddingTop: token('space.0'),
		paddingRight: token('space.0'),
		paddingBottom: token('space.0'),
		paddingLeft: token('space.0'),
		borderRadius: token('radius.full'),
		color: token('color.text.subtlest'),
		'&:hover': {
			color: token('color.text.accent.gray'),
		},
	},
});

// EM-2028 TODO: We are rendering both icons and hiding them via CSS display rule because
// the Popup component's ref is not correctly updated when this react-select component
// rerenders. i.e. it does not  update the refs when one of these components rerenders.
export const DropdownIndicator = (props: DropdownIndicatorProps<SelectOption, boolean>) => {
	return (
		<components.DropdownIndicator {...props}>
			<div
				css={[
					fg('slv-117-nin-column-picker-style-updates')
						? styles.dropdownIndicatorWrapper
						: styles.dropdownIndicatorWrapperOld,
				]}
			>
				<DisplayWrapper displayFlag={props.selectProps.inputValue}>
					{fg('slv-117-nin-column-picker-style-updates') ? (
						<Pressable
							xcss={styles.iconWrapper}
							onClick={(event: MouseEvent) => {
								event.preventDefault();
								props.selectProps.onInputChange &&
									props.selectProps.onInputChange('', {
										action: 'input-change',
										prevInputValue: props.selectProps.inputValue,
									});
							}}
							// Clear button should not be focusable
							// see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
							tabIndex={-1}
						>
							<CloseIcon label="" />
						</Pressable>
					) : (
						<CloseIconWrapper
							data-testid="jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon"
							onClick={(event: MouseEvent) => {
								event.preventDefault();
								props.selectProps.onInputChange &&
									props.selectProps.onInputChange('', {
										action: 'input-change',
										prevInputValue: props.selectProps.inputValue,
									});
							}}
						>
							<CloseIcon label="" />
						</CloseIconWrapper>
					)}
				</DisplayWrapper>
			</div>
		</components.DropdownIndicator>
	);
};

export default DropdownIndicator;
